import { UpdatesNotepad } from "@/components/UpdatesNotepad";
import React from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { MobileTopBar, useMobileMenu } from "@/components/MobileTopBar";
import { useAuth } from "@/AuthContext";
import { LayoutDashboard, Users, AlertTriangle, Megaphone, LogOut, Flag, Globe, TreePine } from "lucide-react";
import { Button } from "@/components/ui/button";
import PasswordChangeReminder from "@/components/PasswordChangeReminder";

const nav = [
  { to: "/syndicat", label: "Vue d'ensemble", icon: LayoutDashboard, end: true },
  { to: "/syndicat/adherents", label: "Adhérents", icon: Users },
  { to: "/syndicat/plaintes", label: "Plaintes", icon: AlertTriangle },
  { to: "/syndicat/actualites", label: "Actualités", icon: Megaphone },
  { to: "/syndicat/site", label: "Site web Pro", icon: Globe },
  { to: "/syndicat/billetterie", label: "Billetterie & Parcs", icon: TreePine },
];

export default function SyndicatLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const mobile = useMobileMenu();
  const doLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="dashboard-shell bg-white">
      <MobileTopBar portal="syndicat" label="Syndicat" open={mobile.open} onToggle={mobile.toggle} dark accent="#FFD700" />
      <aside className={`${mobile.asideClass} border-r border-[#DEE2E6] bg-[#0A0A0A] text-white flex-col`} onClick={mobile.onNavClick} data-testid="syndicat-sidebar">
        <div className="p-6 border-b border-white/10 hidden lg:block">
          <Link to="/" className="flex items-center gap-3" data-testid="syndicat-brand">
            <img src="/pag-logo.png" alt="PAG" className="h-9 w-9 object-contain bg-white p-0.5" />
            <span className="font-display font-black text-lg">PAG</span>
            <span className="text-xs uppercase tracking-[0.25em] text-[#FFD700] border-l border-white/20 pl-3 flex items-center gap-1"><Flag className="h-3 w-3" /> Syndicat</span>
          </Link>
        </div>
        <div className="px-6 py-4 border-b border-white/10">
          <div className="text-[10px] uppercase tracking-[0.25em] text-white/40 font-bold">Organisation</div>
          <div className="font-display font-bold text-sm mt-1 truncate">{user?.nom} {user?.prenom}</div>
          <div className="font-mono text-[11px] text-[#FFD700] mt-0.5">{user?.code}</div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`syndicat-nav-${item.label.toLowerCase().replace(/\s+/g, "-").replace(/[éè]/g, "e")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-semibold transition-colors ${
                  isActive ? "bg-white text-[#0A0A0A]" : "text-white/70 hover:bg-white/10 hover:text-white"
                }`
              }
            >
              <item.icon className="h-4 w-4" /> {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <Button onClick={doLogout} data-testid="syndicat-logout" variant="ghost" className="w-full justify-start text-white/70 hover:bg-white/10 hover:text-white">
            <LogOut className="h-4 w-4 mr-2" /> Déconnexion
          </Button>
        </div>
      </aside>
      <main className="overflow-y-auto bg-[#F8F9FA]">
        <PasswordChangeReminder />
        <UpdatesNotepad className="mx-6 lg:mx-10 mt-4" compact />
        <Outlet />
      </main>
    </div>
  );
}
